export const formatName = (person) => {
  if (!person) return "";
  const middleInitial = person.middleInitial ? person.middleInitial : "";
  return toTitleCase(`${person.lastName}, ${person.firstName} ${middleInitial}`);
};

export const formatNameFML = (person) => {
  if (!person) return "";
  const middleInitial = person.middleInitial ? `${person.middleInitial} ` : "";
  return toTitleCase(`${person.firstName} ${middleInitial}${person.lastName}`);
};

export const formatNameFL = (person): string => {
  if (!person) return "";
  return toTitleCase(`${person.firstName} ${person.lastName}`);
};

export const formatNameLF = (person) => {
  if (!person) return "";
  return toTitleCase(`${person.lastName} ${person.firstName}`);
};

export const toTitleCase = (text) =>
  text
    .toLowerCase()
    .split(" ")
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");
